// ==========================================
// FORMLABS ECOSYSTEM LANDING PAGE — MOCK DATA
// ==========================================

// Navigation
export const navItems = [
  { label: "Why Formlabs", href: "#why-formlabs" },
  { label: "Printers", href: "#printers" },
  { label: "Packages", href: "#packages" },
  { label: "Materials", href: "#materials" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "About Us", href: "#about-us" },
];

// ==========================================
// Section 1: Hero + Why Formlabs
// ==========================================
export const heroData = {
  badge: "Authorised Formlabs SLA Partner",
  headline: "Production\u2011Grade Resin Printing Installed, Setup & Generating $$ In Less Than 14 Days",
  subheadline:
    "3D Printer Gear brings the full Formlabs SLA ecosystem to Australia: blazing\u2011fast Form 4 and Form 4L 3D printers, 45+ engineering\u2011grade resins, and a Melbourne showroom where you can see your parts printed live. Backed by 15+ years of hands\u2011on support",
  primaryCta: { label: "Book My Formlabs Workflow Demo", href: "#about-us" },
  primaryCtaSub: "We\u2019ll review your parts, recommend the right Formlabs setup and resins, and show you live print times and costs for your jobs.",
  secondaryCta: { label: "Just want to compare models? View all printers", href: "#printers" },
  heroImage:
    "/images/formlabs_f4_front_cover_closed_eng_light_837ccdd4.png",
  stats: [
    { value: "15+", label: "Years helping Australian teams move from hobby\u2011grade to production\u2011grade printing." },
    { value: "45+", label: "Formlabs resins to cover prototypes, tooling, and regulated medical/dental work." },
    { value: "98.7%", label: "Independent print success rate on Form 4 \u2014 stop losing time to failed prints." },
    { value: "<2hrs", label: "Most day\u2011to\u2011day parts in under 2 hours for same\u2011day iteration." },
  ],
};

export const advantages = [
  {
    icon: "Zap",
    title: "Blazing Fast Print Speeds",
    description:
      "Most prints complete in under 2 hours. Form 4's MSLA engine delivers up to 100mm/hour \u2014 whether you print one part or fill the entire build plate.",
    image:
      "/images/03082024_dsl_speed_bp_184-sh-standard.jpg",
  },
  {
    icon: "Target",
    title: "Industrial Precision",
    description:
      "50\u00B5m XY resolution with tuned anti-aliasing delivers subpixel detail. Typical tolerances of \u00B10.15% ensure parts match your design, every time.",
    image:
      "/images/f4_3.jpg.jpg",
  },
  {
    icon: "Layers",
    title: "45+ Advanced Materials",
    description:
      "From rigid and tough engineering resins to flexible elastomers, castable wax, and biocompatible medical materials \u2014 the widest SLA resin library available.",
    image:
      "/images/optimized_for_web_jpeg-08292018_mfg_parts_098_flat.jpg.jpg",
  },
  {
    icon: "Shield",
    title: "98.7% Print Success Rate",
    description:
      "Validated settings, sensor-driven control, and factory calibration minimise failed prints. Third-party tested reliability you can depend on.",
    image:
      "/images/factory_solutions_agile_factory.jpg.jpg",
  },
  {
    icon: "Monitor",
    title: "Intuitive Software Ecosystem",
    description:
      "PreForm handles print preparation with guided workflows. Dashboard provides remote monitoring, alerts, and fleet management from anywhere.",
    image:
      "/images/f4_1_new.jpg.jpg",
  },
  {
    icon: "Award",
    title: "World's #1 SLA Manufacturer",
    description:
      "Founded by MIT engineers, Formlabs is the largest professional SLA 3D printer manufacturer globally. Trusted by Ford, Microsoft, and thousands of teams.",
    image:
      "/images/09232024_f4l_lawr_loc_0181-edit.jpg.jpg",
  },
];

export const industries = [
  {
    name: "Engineering",
    subtitle: "Product Design & Prototyping",
    icon: "Cog",
    image: "https://images.unsplash.com/photo-1769151174211-a1b2d41117bd?w=400&q=50",
  },
  {
    name: "Manufacturing",
    subtitle: "Tooling, Jigs & Fixtures",
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1632914146475-bfe6fa6b2a12?w=400&q=50",
  },
  {
    name: "Automotive",
    subtitle: "Parts & Rapid Prototyping",
    icon: "Car",
    image: "https://images.unsplash.com/photo-1595787142842-7404bc60470d?w=400&q=50",
  },
  {
    name: "Medical",
    subtitle: "Anatomical Models & Devices",
    icon: "HeartPulse",
    image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=400&q=50",
  },
  {
    name: "Dental",
    subtitle: "Models, Guides & Restorations",
    icon: "Smile",
    image: "https://images.unsplash.com/photo-1643386281892-f8417a49130e?w=400&q=50",
  },
  {
    name: "Education",
    subtitle: "Research & Learning Labs",
    icon: "GraduationCap",
    image: "https://images.unsplash.com/photo-1602052577122-f73b9710adba?w=400&q=50",
  },
  {
    name: "Jewelry",
    subtitle: "Casting Patterns & Fine Detail",
    icon: "Gem",
    image: "https://images.unsplash.com/photo-1605100804567-1ffe942b5cd6?w=400&q=50",
  },
  {
    name: "Entertainment",
    subtitle: "Props, Models & Figurines",
    icon: "Clapperboard",
    image: "https://images.unsplash.com/photo-1630935745277-1ed7ddbba9d7?w=400&q=50",
  },
];

// ==========================================
// Section 2: Printers (Phase 2)
// ==========================================
export const printersData = [
  {
    id: "form-4",
    name: "Form 4",
    badge: "Most Popular",
    badgeStyle: "orange",
    tagline: "Blazing Speed Meets Industrial Production",
    description:
      "A blazing fast MSLA 3D printer combining an industry-leading materials library with a reliable, accurate print engine.",
    image:
      "/images/formlabs_f4_front_cover_closed_eng_light_837ccdd4.png",
    buildVolume: "20.0 \u00D7 12.5 \u00D7 21.0 cm",
    technology: "MSLA",
    resolution: "50 \u00B5m XY",
    speed: "Up to 100 mm/hr",
    lightSource: "60 LEDs",
    layerThickness: "25\u2013200 \u00B5m",
    materials: "23+ resins",
    priceFrom: "$7,347",
    priceCurrency: "AUD",
    idealFor: [
      "Rapid prototyping & production",
      "Rapid tooling & manufacturing aids",
      "Patterns for molds & casting",
      "Model making & consumer products",
    ],
    storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4-3d-printer",
  },
  {
    id: "form-4b",
    name: "Form 4B",
    badge: "Medical",
    badgeStyle: "teal",
    tagline: "Blazing Speed Meets Surgical Precision",
    description:
      "Create biocompatible, sterilizable anatomical models and medical devices fast with the most diverse materials library for healthcare.",
    image:
      "/images/f4b_1_new.jpg",
    buildVolume: "20.0 \u00D7 12.5 \u00D7 21.0 cm",
    technology: "MSLA",
    resolution: "50 \u00B5m XY",
    speed: "Up to 100 mm/hr",
    lightSource: "60 LEDs",
    layerThickness: "25\u2013200 \u00B5m",
    materials: "Biocompatible resins",
    priceFrom: "Contact Us",
    priceCurrency: "",
    idealFor: [
      "Biocompatible & sterilizable parts",
      "Medical device prototypes & jigs",
      "Patient-specific anatomical models",
      "Surgical planning models",
    ],
    storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4b-medical-3d-printer",
  },
  {
    id: "form-4l",
    name: "Form 4L",
    badge: "Large Format",
    badgeStyle: "white",
    tagline: "Big Parts, Blazing Fast",
    description:
      "Large-format MSLA printer combining an industry-leading materials library with a reliable, accurate print engine for your biggest ideas.",
    image:
      "/images/f4l_perspl_light_core_v4_ik_240829.png",
    buildVolume: "35.3 \u00D7 19.6 \u00D7 35.0 cm",
    technology: "MSLA",
    resolution: "50 \u00B5m XY",
    speed: "Up to 100 mm/hr",
    lightSource: "145 LEDs",
    layerThickness: "25\u2013200 \u00B5m",
    materials: "19+ resins",
    priceFrom: "Contact Us",
    priceCurrency: "",
    idealFor: [
      "Full-size rapid prototyping",
      "Large-scale models & assemblies",
      "High throughput production",
      "Rapid tooling & manufacturing aids",
    ],
    storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4l-3d-printer",
  },
  {
    id: "form-4bl",
    name: "Form 4BL",
    badge: "Large Medical",
    badgeStyle: "teal",
    tagline: "A New Era of Medical Manufacturing",
    description:
      "Large-format medical 3D printer with the most diverse materials library for healthcare. Biocompatible, sterilizable outputs at scale.",
    image:
      "/images/f4l_perspl_light_med_v4_ik_240829.png",
    buildVolume: "35.3 \u00D7 19.6 \u00D7 35.0 cm",
    technology: "MSLA",
    resolution: "50 \u00B5m XY",
    speed: "Up to 100 mm/hr",
    lightSource: "145 LEDs",
    layerThickness: "25\u2013200 \u00B5m",
    materials: "Biocompatible resins",
    priceFrom: "Contact Us",
    priceCurrency: "",
    idealFor: [
      "Large biocompatible parts",
      "Full-size anatomical models at 1:1",
      "Medical device prototypes & assemblies",
      "Patient-specific surgical tools",
    ],
    storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4bl-medical-3d-printer",
  },
];

// ==========================================
// SLA Workflow Steps
// ==========================================
export const workflowSteps = [
  {
    step: 1,
    title: "Prepare",
    subtitle: "PreForm Software",
    brief: "Import, orient, and validate your model",
    image:
      "/images/preform.png",
    description:
      "Every successful print starts with proper preparation. PreForm\u2019s guided workflow takes your 3D model and intelligently orients it, generates light-touch supports, and runs live printability checks \u2014 catching potential failures before they waste time and resin.",
    keyPoints: [
      "Smart auto-orientation minimises support marks on visible surfaces",
      "Advanced support generation with easy post-print removal",
      "Live printability checks flag issues before you hit print",
      "Anyone can learn the full workflow in under 15 minutes",
    ],
    equipment: "PreForm (Free Software)",
  },
  {
    step: 2,
    title: "Print",
    subtitle: "Form 4 Printer",
    brief: "Load resin, hit print, and walk away",
    image:
      "/images/f4_3.jpg",
    description:
      "Simply load a resin cartridge, select your validated print settings, and start the job. Form 4\u2019s MSLA engine automatically dispenses resin and delivers blazing fast prints with 50\u00B5m pixel precision. Monitor progress remotely via Dashboard.",
    keyPoints: [
      "No-hassle cartridge system \u2014 automatic resin dispensing",
      "Validated print settings for every Formlabs material",
      "Most prints complete in under 2 hours",
      "Remote monitoring and alerts via Dashboard",
    ],
    equipment: "Form 4 / Form 4B / Form 4L / Form 4BL",
  },
  {
    step: 3,
    title: "Wash",
    subtitle: "Form Wash",
    brief: "Automated cleaning removes uncured resin",
    image:
      "/images/formlabs_wash_plus_front_ik_240314_store_noshadow.png",
    description:
      "After printing, parts are coated in uncured resin that must be removed. Form Wash automates this critical step \u2014 submerging parts in solvent with controlled agitation to ensure consistent, clean surfaces every time, regardless of operator.",
    keyPoints: [
      "Automated solvent wash for consistent results",
      "Removes uncured resin critical for accurate dimensions",
      "Clean surfaces ensure proper curing in the next step",
      "Eliminates manual variability between operators",
    ],
    equipment: "Form Wash (Gen 2)",
  },
  {
    step: 4,
    title: "Cure",
    subtitle: "Form Cure",
    brief: "UV post-curing for final material properties",
    image:
      "/images/02172025_form_cure_2nd_gen_002_no_shadow_store.png",
    description:
      "Post-curing is what gives SLA parts their final strength, stiffness, and thermal stability. Form Cure exposes parts to controlled UV light and heat at the precise settings recommended for each resin \u2014 bringing parts to their full mechanical potential.",
    keyPoints: [
      "Controlled UV light + heat for peak material properties",
      "Resin-specific curing profiles for optimal results",
      "Parts reach full strength, stiffness & thermal stability",
      "Without curing, parts may remain soft or dimensionally unstable",
    ],
    equipment: "Form Cure",
  },
];

// ==========================================
// SLA vs FDM Speed Comparison
// ==========================================
export const speedComparisons = [
  {
    id: "game-controller",
    product: "Game Controller",
    company: "Battle Beaver Customs",
    industry: "Consumer Products",
    image:
      "/images/03082024_dsl_speed_bp_184-sh-standard.jpg",
    times: {
      form4: { label: "Form 4", minutes: 98, display: "1h 38min" },
      fdm: { label: "Benchmark FDM", minutes: 217, display: "3h 37min" },
      sla: { label: "Benchmark SLA", minutes: 251, display: "4h 11min" },
      form3: { label: "Form 3+", minutes: 647, display: "10h 47min" },
    },
  },
  {
    id: "led-light-bar",
    product: "LED Light Bar & Mount",
    company: "Holley",
    industry: "Automotive",
    image:
      "/images/03082024_dsl_speed_bp_217-sh-standard.jpg",
    times: {
      form4: { label: "Form 4", minutes: 169, display: "2h 49min" },
      fdm: { label: "Benchmark FDM", minutes: 268, display: "4h 28min" },
      sla: { label: "Benchmark SLA", minutes: 412, display: "6h 52min" },
      form3: { label: "Form 3+", minutes: 635, display: "10h 35min" },
    },
  },
  {
    id: "robotic-finger",
    product: "Robotic Finger",
    company: "RightHand Robotics",
    industry: "Robotics",
    image:
      "/images/03082024_dsl_speed_bp_237-sh-standard.jpg",
    times: {
      form4: { label: "Form 4", minutes: 121, display: "2h 1min" },
      fdm: { label: "Benchmark FDM", minutes: 234, display: "3h 54min" },
      sla: { label: "Benchmark SLA", minutes: 217, display: "3h 37min" },
      form3: { label: "Form 3+", minutes: 511, display: "8h 31min" },
    },
  },
  {
    id: "tower-cap",
    product: "Tower Cap",
    company: "Formlabs",
    industry: "Engineering",
    image:
      "/images/03082024_dsl_speed_bp_249-sh-standard.jpg",
    times: {
      form4: { label: "Form 4", minutes: 97, display: "1h 37min" },
      fdm: { label: "Benchmark FDM", minutes: 332, display: "5h 32min" },
      sla: { label: "Benchmark SLA", minutes: 278, display: "4h 38min" },
      form3: { label: "Form 3+", minutes: 269, display: "4h 29min" },
    },
  },
  {
    id: "connector",
    product: "Connector",
    company: "Electrical",
    industry: "Electronics",
    image:
      "/images/03082024_dsl_speed_bp_247-sh-standard.jpg",
    times: {
      form4: { label: "Form 4", minutes: 88, display: "1h 28min" },
      fdm: { label: "Benchmark FDM", minutes: 552, display: "9h 12min" },
      sla: { label: "Benchmark SLA", minutes: 136, display: "2h 16min" },
      form3: { label: "Form 3+", minutes: 583, display: "9h 43min" },
    },
  },
];

// ==========================================
// Section 3: Packages (Phase 3)
// ==========================================
export const packagesData = {
  "form-4": {
    name: "Form 4",
    tiers: [
      {
        name: "Printer",
        price: "$7,347",
        currency: "AUD",
        description: "The printer and core essentials to start printing right away.",
        recommended: false,
        image: "/images/70725.jpg",
        items: [
          { name: "Form 4 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: false },
          { name: "Finish Kit", included: false },
          { name: "Form Wash (Gen 2)", included: false },
          { name: "Form Cure", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: false },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4-3d-printer",
      },
      {
        name: "Basic",
        price: "$7,127",
        currency: "AUD",
        description: "Print-ready starter bundle with daily essentials and warranty coverage.",
        recommended: false,
        image: "/images/70747.png",
        items: [
          { name: "Form 4 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: true },
          { name: "Finish Kit", included: true },
          { name: "Form Wash (Gen 2)", included: false },
          { name: "Form Cure", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4-3d-printer-basic-package",
      },
      {
        name: "Complete",
        price: "$10,794",
        currency: "AUD",
        description: "The full workflow \u2014 print, wash, and cure with all accessories included.",
        recommended: true,
        image: "/images/70748.jpg",
        items: [
          { name: "Form 4 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Plate Flex", included: true },
          { name: "Mixer", included: true },
          { name: "Finishing Kit", included: true },
          { name: "Form Wash (Gen 2)", included: true },
          { name: "Form Cure", included: true },
          { name: "Solvent Pump", included: true },
          { name: "PreForm Software", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4-3d-printer-complete-package",
      },
    ],
  },
  "form-4b": {
    name: "Form 4B",
    tiers: [
      {
        name: "Printer",
        price: "$11,032",
        currency: "AUD",
        description: "The medical-grade printer with core accessories.",
        recommended: false,
        image: "/images/70726.jpg",
        items: [
          { name: "Form 4B 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: false },
          { name: "Finish Kit", included: false },
          { name: "Form Wash (Gen 2)", included: false },
          { name: "Form Cure", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: false },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4b-medical-3d-printer",
      },
      {
        name: "Basic",
        price: "$11,079",
        currency: "AUD",
        description: "Medical print-ready setup with daily essentials and warranty.",
        recommended: false,
        image: "/images/70749.png",
        items: [
          { name: "Form 4B 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: true },
          { name: "Finish Kit", included: true },
          { name: "Form Wash (Gen 2)", included: false },
          { name: "Form Cure", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4b-medical-3d-printer-basic-package",
      },
      {
        name: "Complete",
        price: "$14,581",
        currency: "AUD",
        description: "Full medical workflow \u2014 print, wash, cure with all accessories.",
        recommended: true,
        image: "/images/70750.jpg",
        items: [
          { name: "Form 4B 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Plate Flex", included: true },
          { name: "Mixer", included: true },
          { name: "Finishing Kit", included: true },
          { name: "Form Wash (Gen 2)", included: true },
          { name: "Form Cure", included: true },
          { name: "Solvent Pump", included: true },
          { name: "PreForm Software", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4b-medical-3d-printer-complete-packa",
      },
    ],
  },
  "form-4l": {
    name: "Form 4L",
    tiers: [
      {
        name: "Printer",
        price: "$21,802",
        currency: "AUD",
        description: "The large-format printer with core accessories.",
        recommended: false,
        image: "/images/70728.jpg",
        items: [
          { name: "Form 4L 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: false },
          { name: "Finish Kit", included: false },
          { name: "Form Wash L", included: false },
          { name: "Form Cure L", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: false },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4l-3d-printer",
      },
      {
        name: "Basic",
        price: "$20,368",
        currency: "AUD",
        description: "Large-format print-ready setup with essentials and warranty.",
        recommended: false,
        image: "/images/70751.png",
        items: [
          { name: "Form 4L 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: true },
          { name: "Finish Kit", included: true },
          { name: "Form Wash L", included: false },
          { name: "Form Cure L", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4l-3d-printer-basic-package",
      },
      {
        name: "Complete",
        price: "$37,888",
        currency: "AUD",
        description: "Full large-format workflow \u2014 print, wash, cure with everything included.",
        recommended: true,
        image: "/images/70752.jpg",
        items: [
          { name: "Form 4L 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Plate Flex", included: true },
          { name: "Mixer", included: true },
          { name: "Finishing Kit", included: true },
          { name: "Form Wash L", included: true },
          { name: "Form Cure L", included: true },
          { name: "Resin Pumping System", included: true },
          { name: "PreForm Software", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4l-3d-printer-complete-package",
      },
    ],
  },
  "form-4bl": {
    name: "Form 4BL",
    tiers: [
      {
        name: "Printer",
        price: "$26,388",
        currency: "AUD",
        description: "Large-format medical printer with core accessories.",
        recommended: false,
        image: "/images/70727.jpg",
        items: [
          { name: "Form 4BL 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: false },
          { name: "Finish Kit", included: false },
          { name: "Form Wash L", included: false },
          { name: "Form Cure L", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: false },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4bl-medical-3d-printer",
      },
      {
        name: "Basic",
        price: "$25,463",
        currency: "AUD",
        description: "Large medical print-ready setup with essentials and warranty.",
        recommended: false,
        image: "/images/70753.png",
        items: [
          { name: "Form 4BL 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Platform", included: true },
          { name: "Mixer", included: true },
          { name: "Finish Kit", included: true },
          { name: "Form Wash L", included: false },
          { name: "Form Cure L", included: false },
          { name: "Solvent Pump", included: false },
          { name: "12 Months Warranty", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4bl-medical-3d-printer-basic-package",
      },
      {
        name: "Complete",
        price: "$42,777",
        currency: "AUD",
        description: "Full large medical workflow \u2014 print, wash, cure with all accessories.",
        recommended: true,
        image: "/images/70754.png",
        items: [
          { name: "Form 4BL 3D Printer", included: true },
          { name: "Resin Tank", included: true },
          { name: "Build Plate Flex", included: true },
          { name: "Mixer", included: true },
          { name: "Finishing Kit", included: true },
          { name: "Form Wash L", included: true },
          { name: "Form Cure L", included: true },
          { name: "Resin Pumping System", included: true },
          { name: "PreForm Software", included: true },
        ],
        storeUrl: "https://www.3dprintergear.com.au/formlabs-form-4bl-medical-3d-printer-complete-pack",
      },
    ],
  },
};

// ==========================================
// Section 4: Resins (Phase 4)
// ==========================================
export const resinsData = [
  { id: "white-v5", name: "White Resin V5", category: "General Purpose", price: "$125", tags: ["Matte", "High Strength", "Fine Details", "Fast"], description: "Versatile all-rounder with speed, accuracy, and injection mold-rivaling properties.", image: "/images/03122024_print_silhouettes_009-sh-standard_store.png", url: "https://formlabs.com/store/materials/white-resin/" },
  { id: "black-v5", name: "Black Resin V5", category: "General Purpose", price: "$125", tags: ["Matte", "High Strength", "Fine Details", "Fast"], description: "Deep black finish with sharp details. 3x faster than previous versions.", image: "/images/03122024_print_silhouettes_033-sh-standard_store.png", url: "https://formlabs.com/store/materials/black-resin/" },
  { id: "grey-v5", name: "Grey Resin V5", category: "General Purpose", price: "$125", tags: ["Matte", "High Accuracy", "Fine Details"], description: "Ideal for prototyping and detailed models with a clean matte finish.", image: "/images/grey1.png", url: "https://formlabs.com/store/materials/grey-resin-v4/" },
  { id: "clear-v5", name: "Clear Resin V5", category: "General Purpose", price: "$125", tags: ["Transparent", "High Strength", "Fine Details"], description: "Polishes to near-optical transparency for light pipes and fluidic devices.", image: "/images/clear1_1.png", url: "https://formlabs.com/store/materials/clear-resin-v4-1/" },
  { id: "fast-model", name: "Fast Model Resin", category: "General Purpose", price: "$125", tags: ["Fast Printing", "High Throughput"], description: "Formlabs\u2019 fastest resin \u2014 over 100mm/hr. Large prototypes in under 2 hours.", image: "/images/03122024_print_silhouettes_025a-sh-standard_store.png", url: "https://formlabs.com/store/materials/fast-model-resin/" },
  { id: "color-resin", name: "Color Resin", category: "General Purpose", price: "$155", tags: ["Custom Colors", "Matte", "High Accuracy"], description: "Print in any color to match your brand without painting or coating.", image: "/images/05272025_color_resin_v5_097-edit_shadow_store.png", url: "https://formlabs.com/store/materials/color-resin/" },
  { id: "tough-2000-v2", name: "Tough 2000 Resin V2", category: "Engineering", price: "$355", tags: ["ABS-Like", "Impact Resistant", "High Strength"], description: "Rugged ABS-like strength with heat and creep resistance for functional parts.", image: "/images/10152025_tough_2000.png", url: "https://formlabs.com/store/materials/tough-2000-resin/" },
  { id: "tough-1500-v2", name: "Tough 1500 Resin V2", category: "Engineering", price: "$355", tags: ["PP-Like", "Impact Resistant", "Wear Resistant"], description: "Polypropylene-like resilience. Bends and springs back repeatedly.", image: "/images/03042025_tough_1500_v2_522_no_shadow_store.png", url: "https://formlabs.com/store/materials/tough-1500-resin/" },
  { id: "rigid-10k", name: "Rigid 10K Resin", category: "Engineering", price: "$465", tags: ["Glass Filled", "Ultra Stiff", "Heat Resistant"], description: "Extremely stiff glass-filled resin for molds, jigs, and high-temp tooling.", image: "/images/rigid_10k_1.png", url: "https://formlabs.com/store/materials/rigid-10k-resin/" },
  { id: "rigid-4000", name: "Rigid 4000 Resin", category: "Engineering", price: "$355", tags: ["Glass Filled", "PEEK-Like", "Ultra Stiff"], description: "PEEK-like stiffness with smooth finish for industrial load-bearing parts.", image: "/images/rigid4000_1.png", url: "https://formlabs.com/store/materials/rigid-resin/" },
  { id: "high-temp", name: "High Temp Resin", category: "Engineering", price: "$309", tags: ["Heat Resistant", "Ultra Stiff", "238\u00B0C HDT"], description: "Highest HDT at 238\u00B0C. For molds, hot air flow, and heat-resistant fixtures.", image: "/images/high_temp_1.png", url: "https://formlabs.com/store/materials/high-temp-resin/" },
  { id: "durable", name: "Durable Resin", category: "Engineering", price: "$355", tags: ["PE-Like", "Low Friction", "Wear Resistant"], description: "Pliable, impact-resistant with low friction \u2014 like polyethylene (PE).", image: "/images/durable_1.png", url: "https://formlabs.com/store/materials/durable-resin/" },
  { id: "esd", name: "ESD Resin", category: "Engineering", price: "$355", tags: ["ESD-Safe", "ABS-Like", "Robust"], description: "Static-dissipative resin for electronics manufacturing tooling.", image: "/images/11252021_esd_resin_139_copy_s.png", url: "https://formlabs.com/store/materials/esd-resin/" },
  { id: "flexible-80a", name: "Flexible 80A Resin", category: "Elastomeric", price: "$309", tags: ["Rubber-Like", "Shore 80A", "Wear Resistant"], description: "Stiff soft-touch elastomer for prototyping rubber and TPU parts.", image: "/images/flexible_80a_1.png", url: "https://formlabs.com/store/materials/flexible-80a-resin/" },
  { id: "elastic-50a", name: "Elastic 50A Resin", category: "Elastomeric", price: "$309", tags: ["Soft", "Shore 50A", "Tear Resistant"], description: "Soft, compressible elastomer for cushioning, gaskets, and wearables.", image: "/images/biomed_amber2_6.png", url: "https://formlabs.com/store/materials/elastic-50a-resin/" },
  { id: "silicone-40a", name: "Silicone 40A Resin", category: "Elastomeric", price: "$465", tags: ["True Silicone", "Shore 40A", "Biocompatible"], description: "First 3D printable pure silicone \u2014 soft, stretchy, and biocompatible.", image: "/images/durable_1.png", url: "https://formlabs.com/store/materials/silicone-40a-resin/" },
  { id: "castable-wax-40", name: "Castable Wax 40 Resin", category: "Casting", price: "$399", tags: ["40% Wax Filled", "Fine Details", "Clean Burnout"], description: "Wax-filled for investment casting of intricate jewelry and complex parts.", image: "/images/cw40_1.png", url: "https://formlabs.com/store/materials/castable-wax-40-resin/" },
  { id: "castable-wax", name: "Castable Wax Resin", category: "Casting", price: "$465", tags: ["20% Wax Filled", "Ultrafine", "Zero Ash"], description: "20% wax for ultrafine jewelry casting with smooth surfaces.", image: "/images/castable_wax_1.png", url: "https://formlabs.com/store/materials/castable-wax-resin/" },
  { id: "true-cast", name: "True Cast Resin", category: "Casting", price: "$309", tags: ["Wax Filled", "Fine Details", "Precision Casting"], description: "Precision casting for intricate jewelry and engineering components up to 5mm.", image: "/images/04212025_truecast_sample_x7_237-edit_shadow_store.png", url: "https://formlabs.com/store/materials/true-cast-resin/" },
  { id: "biomed-black", name: "BioMed Black Resin", category: "Medical", price: "$389", tags: ["Biocompatible", "Sterilizable", "Matte"], description: "Rigid matte black for biocompatible devices with skin/mucosal contact.", image: "/images/biomed_black_1.png", url: "https://formlabs.com/store/materials/biomed-black-resin/" },
  { id: "biomed-clear", name: "BioMed Clear Resin", category: "Medical", price: "$539", tags: ["Biocompatible", "Sterilizable", "Transparent"], description: "Hard, strong, and transparent for breathing pathways and long-term skin contact.", image: "/images/optimized_for_web_png-06302025_biomed_cl_6fdf1023.png", url: "https://formlabs.com/store/materials/biomed-clear-resin/" },
  { id: "biomed-amber", name: "BioMed Amber Resin", category: "Medical", price: "$389", tags: ["Biocompatible", "Sterilizable", "High Strength"], description: "Strong, stiff resin for sterilizable biocompatible medical applications.", image: "/images/biomed_amber2_6.png", url: "https://formlabs.com/store/materials/biomed-amber-resin/" },
  { id: "surgical-guide", name: "Surgical Guide Resin", category: "Dental", price: "$389", tags: ["Biocompatible", "Autoclavable", "Translucent"], description: "Autoclavable resin for dental surgical guides and drilling templates.", image: "/images/surgical_guide_1.png", url: "https://formlabs.com/store/materials/surgical-guide-resin/" },
  { id: "dental-lt-clear", name: "Dental LT Clear V2", category: "Dental", price: "$539", tags: ["Biocompatible", "Transparent", "Wear Resistant"], description: "Long-term biocompatible material for splints and occlusal guards.", image: "/images/dental_lt_clearv2_1.png", url: "https://formlabs.com/store/materials/dental-lt-clear-resin-v2/" },
  { id: "custom-tray", name: "Custom Tray Resin", category: "Dental", price: "$389", tags: ["Biocompatible", "Fast Printing", "Translucent"], description: "Fast-printing biocompatible material for dental impression trays.", image: "/images/custom_tray_1.png", url: "https://formlabs.com/store/materials/custom-tray-resin/" },
];

export const resinCategories = [
  "All",
  "General Purpose",
  "Engineering",
  "Elastomeric",
  "Casting",
  "Medical",
  "Dental",
];

// ==========================================
// Section 5: Case Studies (Phase 5)
// ==========================================
export const caseStudiesData = [
  {
    company: "Ford",
    industry: "Automotive",
    application: "Rapid Prototyping",
    quote: "Working with Form 4, it\u2019s really a game-changer. The speed of the printer will change our workflow. We can deliver more parts, the throughput is higher. We are much more flexible if we have short-time requests.",
    person: "Sandro Piroddi",
    title: "Supervisor of the Rapid Technology Center, Ford",
    image: "/images/optimized_for_web_jpeg-04112024_ford_use_6ce3d83e.jpg",
    url: "https://formlabs.com/blog/ford-new-explorer-sla-sls-3d-printing/",
  },
  {
    company: "Microsoft",
    industry: "Engineering",
    application: "Rapid Prototyping",
    quote: "Form 4 is our go-to choice for projects needing tight tolerances and engineering-grade materials. It produces high-performance parts with amazingly fast print times and makes it possible for our model makers to produce multiple iterations in a 24-hour period.",
    person: "Mark Honschke",
    title: "Additive Prototyping Lead, Microsoft APC",
    image: "/images/microsoft_user_story.jpg",
    url: "https://formlabs.com/blog/formlabs-microsoft-apc-form-4l-sla-fuse-sls-3d-printing/",
  },
  {
    company: "Black Diamond",
    industry: "Consumer Products",
    application: "Rapid Prototyping",
    quote: "On one lighting project, we did three iterations in a single day \u2014 designed and printed three different parts before we had a meeting in the afternoon.",
    person: "Matt Tetzl",
    title: "Product Design Lab Manager, Black Diamond",
    image: "/images/black_diamond_headlamp.jpg",
    url: "https://formlabs.com/blog/how-black-diamond-prototypes-gear/",
  },
  {
    company: "OXO",
    industry: "Consumer Products",
    application: "Rapid Prototyping",
    quote: "Form 4 has transformed our workflow. In the past, our queue has often been an issue based on time. With Form 4, it throws that out the window \u2014 we\u2019re no longer constrained by time.",
    person: "Jesse Emanuel",
    title: "Test Engineer, OXO",
    image: "/images/f4_oxo.jpg",
    url: "https://formlabs.com/blog/oxo-3d-printing-formlabs-form-4/",
  },
  {
    company: "NASA",
    industry: "Aerospace",
    application: "Engineering & R&D",
    quote: "The dramatic increase in print speed for Form 4 has significantly accelerated our fabrication cycle \u2014 to the point where I can iterate through many different designs every day and go from design to usable, functional part within the hour.",
    person: "Matt Mullin",
    title: "Laser Engineer, NASA",
    image: "/images/crew_dragon_at_the_iss_for_demo_mission_1_cropped.jpg",
    url: "https://formlabs.com/blog/nasa-sends-formlabs-parts-to-space-aboard-spacex-dragon-resupply-capsule/",
  },
  {
    company: "Hasbro",
    industry: "Entertainment",
    application: "Rapid Prototyping",
    quote: "I really appreciate the reliability paired with the speed. It\u2019s not one or the other, like many other tools. Now I can commit to internal deadlines and feel confident that I can deliver every time.",
    person: "Robert Mackowiak",
    title: "Rapid Prototyping Engineer, Hasbro",
    image: "/images/04132022_hasbro-v2_193_sh-standard.jpg",
    url: "https://formlabs.com/blog/formlabs-hasbro-3d-printing-mass-customization/",
  },
];

// ==========================================
// FAQ
// ==========================================
export const faqData = [
  {
    question: "What is SLA 3D printing and how does it differ from FDM?",
    answer: "SLA (Stereolithography) uses a UV light source to cure liquid resin layer by layer, producing parts with incredibly smooth surfaces, fine details, and tight tolerances. FDM (Fused Deposition Modelling) melts plastic filament and extrudes it in layers, which often results in visible layer lines and lower precision. SLA is ideal when surface quality, accuracy, and material diversity matter."
  },
  {
    question: "Which Formlabs printer is right for me?",
    answer: "It depends on your application and part size. The Form 4 is perfect for general prototyping and production. The Form 4B is designed for medical and dental applications with biocompatible materials. The Form 4L handles large-format parts up to 35cm tall. The Form 4BL combines large format with medical-grade capabilities. Our team can help you choose \u2014 just get in touch."
  },
  {
    question: "What's the difference between the Printer, Basic, and Complete packages?",
    answer: "The Printer package includes just the printer and essential accessories (tank + build platform). The Basic package adds a mixer, finish kit, and 12-month warranty. The Complete package is the full workflow \u2014 printer, Form Wash, Form Cure, and all accessories needed to go from print to finished part. We recommend Complete for the best experience."
  },
  {
    question: "Can I get a free test print before purchasing?",
    answer: "Absolutely. We offer free sample prints so you can see and feel the quality of Formlabs SLA printing in your chosen resin. Just fill out the contact form below or call us on 1300 334 327 and we'll arrange a sample for your specific application."
  },
  {
    question: "Do you offer after-sales support and repairs?",
    answer: "Yes. We have a full in-house service and repair centre in Melbourne. We don't just sell printers \u2014 we support them for the long haul. Our team can help with troubleshooting, maintenance, repairs, and even training for your team."
  },
  {
    question: "What resins are available and how do I choose?",
    answer: "Formlabs offers 45+ SLA resins covering general purpose, engineering (Tough, Rigid, High Temp), elastomeric (Flexible, Elastic, Silicone), casting (Castable Wax), medical (BioMed range), and dental applications. Tell us what you're printing and we'll recommend the ideal resin for your use case."
  },
  {
    question: "Are the prices on this page in AUD?",
    answer: "Yes, all printer and package prices shown are in Australian Dollars (AUD) including GST. Resin prices are approximate AUD conversions \u2014 contact us for exact current pricing. We also offer special pricing for government, education, and reseller accounts."
  },
  {
    question: "Can I visit the showroom?",
    answer: "Yes! Our Melbourne showroom at 781 High Street, Reservoir is open Mon\u2013Fri 9am\u20136pm and Saturday 10am\u20134pm. No appointment needed during business hours. Come see every Formlabs printer running live, touch the parts, and talk to our expert team."
  },
  {
    question: "Do you ship Australia-wide?",
    answer: "Yes, we ship to all Australian states and territories. We offer standard, priority, and express shipping options. Same-day dispatch for orders received before 3pm AEST. Free pickup is also available from our Melbourne store."
  },
  {
    question: "Can I use third-party resins with Formlabs printers?",
    answer: "Yes. All Form 4 series printers support Open Material Mode, which allows you to use compatible third-party resins. For validated workflows (especially medical and dental), we recommend sticking with Formlabs' own resin ecosystem for the most reliable results."
  },
];


// ==========================================
// Section 6: About 3D Printer Gear (Phase 6)
// ==========================================
export const aboutData = {
  headline: "Your Local Formlabs Experts",
  subheadline: "Visit our Melbourne showroom, meet the team, and see Formlabs printers in action. We\u2019ve been helping Australians succeed with 3D printing since 2012.",
  features: [
    { title: "Full Showroom", description: "See every Formlabs printer running live. Touch the parts, compare the resins, and experience the workflow before you buy." },
    { title: "Expert Team", description: "Our team has 15+ years of hands-on 3D printing experience. We\u2019ll help you find the right printer, resin, and setup for your exact application." },
    { title: "Service & Repairs", description: "Full in-house service and repair area. We don\u2019t just sell printers \u2014 we support them for the long haul." },
    { title: "Free Test Samples", description: "Not sure which resin suits your project? We\u2019ll print a sample part in your chosen material so you can test before you commit." },
  ],
  contact: {
    phone: "1300 334 327",
    email: "admin@3dprintergear.com.au",
    address: "781 High Street, Reservoir, Melbourne VIC 3073",
    hours: "Mon\u2013Fri: 9am\u20136pm | Sat: 10am\u20134pm | Sun: By Appointment",
    storeUrl: "https://www.3dprintergear.com.au",
  },
};
